import { Button, CircularProgress } from "@material-ui/core";
import React from "react";
import Axios from "../../state/utils/api-caller";
import { get } from "../../utils";
import { downloadFile } from "../../utils/download";

interface PdfDataColumn {
  title: string;
  dataIndex: string;
}

export interface PdfTableBoundary {
  currentHeight: number;
  totalHeight: number;
}

interface PdfDataTableProps {
  title?: string;
  columns: PdfDataColumn[];
  data: any[];
  downloadPath: string;
  onClick?: (row: any, unselect?: boolean) => void;
  onScroll?: (bound: PdfTableBoundary) => void;
}

export const PdfDataTable: React.FC<PdfDataTableProps> = (props: any) => {
  const { title, columns, data, onClick, onScroll, downloadPath } = props;

  const loadingList: { [key: string]: boolean; } = {};
  for (let i = 0; i < data.length; i++) {
    loadingList[i] = false;
  }
  const [loading, setLoading] = React.useState<{ [key: string]: boolean; }>(loadingList);

  const ref = React.useRef<HTMLTableSectionElement>(null);

  const handleOnScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const { scrollHeight, scrollTop } = event.currentTarget;
    if (onScroll) {
      onScroll({ totalHeight: scrollHeight, currentHeight: scrollTop });
    }
  };

  const handleOnClick = (path: string, fileName: string, index: number) => {
    setLoading((prev: any) => ({
      ...prev,
      [index]: true,
    }));
    Axios.get(path + fileName)
      .then((res) => {
        setLoading((prev: any) => ({
          ...prev,
          [index]: false,
        }));
        downloadFile(fileName, new Blob([new Uint8Array(res.data.data)], { type: "application/pdf" }));
      })
  };

  return (
    <div className="portal-datatable" onScroll={handleOnScroll}>
      <table cellPadding={5} cellSpacing={0}>
        {title && <caption>{title}</caption>}
        <thead>
          <tr>
            {columns.map((item: any) => (
              <th key={item.title}>{item.title}</th>
            ))}
            <th>Download</th>
          </tr>
        </thead>
        <tbody ref={ref}>
          {data.map((row: any, index: number) => (
            <tr
              key={index}
              onClick={(evt: any) => {
                const { classList } = evt.currentTarget;
                if (onClick) {
                  if (classList.contains("selected")) {
                    classList.remove("selected");
                    onClick(row, true);
                  } else {
                    if (ref.current) {
                      ref.current
                        .querySelectorAll("tr.selected")
                        .forEach((row: any) => row.classList.remove("selected"));
                    }
                    classList.add("selected");
                    onClick(row);
                  }
                }
              }}
            >
              {columns.map((key: any) => (
                <td key={key.dataIndex}>{get(row, key.dataIndex)}</td>
              ))}
              {
                row.downloadable === true ?
                  <td style={{ width: "10%" }}>
                    <Button
                      variant="contained"
                      onClick={(evt: any) => handleOnClick(downloadPath, row.fileName, index,)}
                      disabled={loading[index]}
                    >
                      Download
                      {
                        loading[index] && (
                          <CircularProgress
                            size={24}
                            style={{
                              color: 'green',
                              textAlign: 'center',
                              position: 'absolute'
                            }}
                          />
                        )
                      }
                    </Button>
                  </td>
                  : <td />
              }
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
